import { useState, useEffect } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { colors, spacing, fontSizes } from 'ui/theme';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateForSave, displayDate } from 'utils/date';
import { DatePickerWithCollapsibleCalendar } from 'ui/datePicker';
import { getTrialEndDateRequest, updateTrialEndDateRequest } from 'modules/billing/actions';
import { selectTrialEndDate } from 'modules/billing/selectors';

const ExpirationDateContainer = styled.div`
  color: ${colors.red100};
  font-size: ${fontSizes.s12};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

// type Props = {
//   isOpen: boolean,
//   onClose: () => void,
// };

export const ExtendTrialModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const trialEndDate = useSelector(selectTrialEndDate);
  const [localTrialEndDate, setLocalTrialEndDate] = useState(trialEndDate);

  useEffect(() => {
    if (isOpen) {
      dispatch(getTrialEndDateRequest());
    }
  }, [isOpen, dispatch]);

  const updateTrialEndDate = (date) => dispatch(updateTrialEndDateRequest(date));
  const handleDateChange = (endDate) => {
    setLocalTrialEndDate(moment(endDate));
  };

  const updateTrialExpiration = () => {
    updateTrialEndDate(localTrialEndDate ? formatDateForSave(localTrialEndDate) : null);
    onClose();
  };

  return isOpen ? (
    <Modal id="extendTrialModal" isModalOpen={isOpen} onClose={onClose} size={MODAL_SIZES.SMALL}>
      <ModalHeader>
        Update Trial End Date
        <ExpirationDateContainer>
          (Current Expiration Date: {displayDate(moment(trialEndDate))})
        </ExpirationDateContainer>
      </ModalHeader>
      <ModalBody>
        <ContentContainer>
          <DatePickerWithCollapsibleCalendar
            date={localTrialEndDate}
            id="expiration-date-input"
            onDateChange={handleDateChange}
            canClearDate
          />
        </ContentContainer>
      </ModalBody>
      <ModalFooter onClose={onClose}>
        <PrimaryButton onClick={updateTrialExpiration}>Save</PrimaryButton>
      </ModalFooter>
    </Modal>
  ) : null;
};
